import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-wrapper',
  templateUrl: './image-wrapper.component.html',
  styleUrls: ['./image-wrapper.component.scss']
})
export class ImageWrapperComponent {

  @Input() media: string | undefined;

  loading: boolean = true;

  onLoad() {
    this.loading = false;
  }

  getImage() {
    return this.media ? this.media : '../../../assets/images/placeholder_star.svg';
  }

  onError() {
    this.media = '../../../assets/images/placeholder_star.svg';
  }

}
